import { acquireTokenWithoutTelemetry } from '../../authentication';
import { getTelemetryClientConfig } from '../telemetryStore';

type GetAuthToken = () => Promise<string | null>;
export const getAuthToken: GetAuthToken = async () => {
  const { resource } = getTelemetryClientConfig();
  try {
    return await acquireTokenWithoutTelemetry([resource]);
  } catch {
    return null;
  }
};
